import { Map } from 'lucide-react'

interface MapTypeProps {
  initialStyle: string
  handleStyleChange(style: string): void
}

export function MapType({
  initialStyle = 'outdoors-v12',
  handleStyleChange,
}: MapTypeProps) {
  return (
    <div className="flex flex-col gap-2 rounded-lg">
      <div className="flex items-center gap-2 text-nowrap">
        <Map className="size-4 text-monochromatic-500 lg:size-6" />
        <span className="text-sm font-bold text-monochromatic-500 md:text-base lg:text-lg">
          Tipo de mapa
        </span>
      </div>

      <div className="flex gap-6 text-sm lg:text-lg">
        <div className="flex gap-2">
          <label
            className={
              initialStyle === 'outdoors-v12' ? 'font-bold text-bios-title' : ''
            }
            htmlFor="secondaryRadio"
          >
            Padrão
          </label>
          <input
            id="secondaryRadio"
            type="radio"
            checked={initialStyle === 'outdoors-v12'}
            onChange={() => handleStyleChange('outdoors-v12')}
          />
        </div>
        <div className="flex gap-2">
          <label
            htmlFor="defaultRadio"
            className={
              initialStyle === 'satellite-streets-v12'
                ? 'font-bold text-bios-title'
                : ''
            }
          >
            Satélite
          </label>
          <input
            id="defaultRadio"
            type="radio"
            checked={initialStyle === 'satellite-streets-v12'}
            onChange={() => handleStyleChange('satellite-streets-v12')}
          />
        </div>
      </div>
    </div>
  )
}
